"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asTuple = void 0;
// https://github.com/Microsoft/TypeScript/issues/6310#issuecomment-168365222
var asTuple = function (x) { return x; };
exports.asTuple = asTuple;
//# sourceMappingURL=util.js.map